/* eslint-disable require-jsdoc */
import Cookies from 'js-cookie';
import {shareJwt} from '@/constant/env';
import {appendUserAgent} from '@/constant/env.js';

const isHttps = document.location.protocol === 'https:';
const isApp = () =>
  navigator.userAgent.includes(appendUserAgent) || window.isApp;

// QA demo 模式：trycloudflare.com 等 tunnel domain 在 Public Suffix List，
// browser 拒絕寫入跨 subdomain 的 cookie（寫了也讀不到），改走 localStorage 保證 jwt 能存。
const isQaTunnel = () => {
  try {
    const h = document.location.hostname;
    // localhost 不算，避免本地 dev 切到 localStorage jwt 失去 cookie-based 行為
    if (h === 'localhost' || h === '127.0.0.1' || /^192\.168\./.test(h)) return false;
    return /\.trycloudflare\.com$/.test(h) ||
      /\.pages\.dev$/.test(h) ||
      (typeof localStorage !== 'undefined' && localStorage.getItem('__qa_mock__') === '1');
  } catch {
    return false;
  }
};

/**
 * 儲存到使用者端本地資料 (cookie and LocalStorage)
 * @param {String} key key
 * @param {String} data data
 */
function saveLocalData(key, data) {
  if (key === 'jwt' && !isApp()) {
    if (isQaTunnel()) {
      // QA demo domain（trycloudflare.com 等）Public Suffix cookie 寫不進，fallback localStorage
      localStorage.setItem(key, data);
      return;
    }
    if (shareJwt && isHttps) {
      Cookies.set('jwt', data, {
        domain: location.hostname.substring(location.hostname.indexOf('.')),
        expires: 365,
      });
    } else {
      Cookies.set('jwt', data, {expires: 365});
    }
  } else {
    localStorage.setItem(key, data);
  }
}

/**
 * 取得使用者端本地資料 (cookie and LocalStorage)
 * @param {String} key key
 * @return {String} 取得的值
 */
function getLocalData(key) {
  if (key === 'jwt' && !isApp()) {
    if (isQaTunnel()) return localStorage.getItem(key);
    return Cookies.get('jwt');
  }
  return localStorage.getItem(key);
}

/**
 * 刪除使用者端本地資料 (cookie and LocalStorage)
 * @param {String} key key
 */
function removeLocalData(key) {
  if (key === 'jwt' && !isApp()) {
    if (shareJwt && isHttps) {
      Cookies.remove('jwt', {
        domain: location.hostname.substring(location.hostname.indexOf('.')),
      });
    }
    Cookies.remove('jwt');
    localStorage.removeItem('jwt');
  } else {
    localStorage.removeItem(key);
  }
}

/**
 * 設定限時儲存使用者端本地資料
 * @param {String} key key
 * @param {String} data key
 * @param {String} expiry key
 */
function setTemporaryData(key, data, expiry) {
  const item = {
    data,
    expiry: Number(expiry),
  };
  localStorage.setItem(key, JSON.stringify(item));
}

/**
 * 取得限時使用者端本地資料
 * @param {String} key key
 * @return {String} 取得的值
 */
function getDataWithExpiry(key) {
  let item = localStorage.getItem(key);
  if (!item) {
    return null;
  }
  item = JSON.parse(item);
  const now = new Date();
  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }
  return item.data;
}

export {
  saveLocalData,
  getLocalData,
  removeLocalData,
  setTemporaryData,
  getDataWithExpiry,
};
